import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

const COOKIE_NAME = 'frontend-offer-card.newbuilding_broker_onboarding_shown';

export const getNewbuildingBrokerOnboardingCookie = () => {
  if (typeof window !== 'undefined') {
    const cookie = parseCookies(document.cookie)[COOKIE_NAME];

    return cookie === '1';
  }

  return false;
};

export const setNewbuildingBrokerOnboardingCookie = () => {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };
  const isLocalhost = typeof window !== 'undefined' && window.location.hostname.indexOf('localhost') > -1;

  if (isLocalhost) {
    cookieConfig.domain = 'localhost';
  }

  setCookie(COOKIE_NAME, '1', cookieConfig);
};
